<template>
  <div>
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"></SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "CustomerLlog",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'clog',
      formInline: {},
      formCtrl: [
        {
          label: "公司名称",
          keyName: "name",
          placeholder: "请填写公司名称",
          type: "text",
        },
        {
          label: "操作时间",
          keyName: "updateTime",
          placeholder: "请选择时间",
          type: "date",
        },
      ],
      cols: [
        { keyName: "name", label: "公司名称", minwidth: 150 },
        { keyName: "updateTest", label: "操作内容", minwidth: 150 },
        { keyName: "operator", label: "操作人", minwidth: 150 },
        { keyName: "updateTime", label: "操作时间", minwidth: 150 },
      ],
    };
  },
  methods: {},
  mounted() { },
};
</script>
